/**
 * MediaSource が無く ManagedMediaSource でのみ MSE 再生できる端末 (iPhone) か
 */
export const isAvailableOnlyMms = (): boolean => {
  return !("MediaSource" in window) && "ManagedMediaSource" in window;
};

/**
 * LL-HLS の再生に必要な MSE 系 API (MediaSource または ManagedMediaSource) が使えるか
 */
export const isAvailableMseOrMms = (): boolean => {
  return "MediaSource" in window || "ManagedMediaSource" in window;
};
